<template>
  <styled-popover-icon
    v-if="isMobile"
    v-on-clickaway="hideHint"
    :is-active="active"
    @click="toggleHint"
    @mouseover="mouseOver"
  >
    <img src="../../../assets/info.svg" />

    <transition name="transition-info">
      <div v-if="active" class="payment-header__info__hint">
        <div class="payment-header__info__hint__title">
          {{ $t('purpose-of-payment') }}
        </div>

        <div class="payment-header__info__hint__description">
          {{ description }}
        </div>
      </div>
    </transition>
  </styled-popover-icon>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';
import styled from 'vue-styled-components';

const iconProps = {
  isActive: Boolean,
};

const styledPopoverIcon = styled('div', iconProps)`
  &:hover {
    cursor: pointer;
    background: var(--primary);
    transition: var(--default_transition);
  }
  background: ${props => (props.isActive ? `var(--primary)` : `var(--placeholder_text_color)`)};
  border-radius: var(--border_radius);
  margin-left: 5px;
  display: flex;
  height: 24px;
  width: 24px;
  img {
    height: 24px;
    width: 24px;
  }
  .payment-header__info__hint {
    background-color: var(--secondary_background_color);
    border: var(--border);
    border-color: var(--border_color);
    border-radius: var(--border_radius);
    box-shadow: var(--box_shadow);

    overflow: hidden;
    &__title {
      color: var(--placeholder_text_color);
      text-align: left;
    }
    &__description {
      color: var(--primary_text_color);
      text-align: left;
    }
  }
`;

export default {
  components: {
    styledPopoverIcon,
  },

  directives: { onClickaway },

  props: {
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },

  methods: {
    toggleHint() {
      this.active = !this.active;
    },

    hideHint() {
      if (this.active) this.active = false;
    },

    mouseOver: function() {
      this.active = !this.active;
    },
  },
};
</script>
